export const storageKeys = {
  AuthToken: 'authentication:token',
  UserName: 'name',
}
